/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
   {
     url: "/home",
     name: "首页",
     slug: "home",
     tag: "2",
     tagColor: "warning",
     icon: "HomeIcon",
     submenu: [
       {
         url: '/home/analytics',
         name: "数据分析",
         slug: "homeAnalytics",
       },
       {
         url: '/home/ecommerce',
         name: "数据统计",
         slug: "homeCommerce",
       },
     ]
   },
   {
     header: "用户",
   },
  {
    url: "/user/myuser",
    name: "我的信息",
    slug: "myuser",
    icon: "UserIcon",
  },
  {
    url: "/user/myculture",
    name: "企业文化考核",
    slug: "myculture",
    icon: "ClipboardIcon",
  },
  {
    url: "/user/myrecords",
    name: "历史记录",
    slug: "myrecords",
    icon: "ArchiveIcon",
  },
  {
     header: "管理",
   },
  {
    url: "/admin/reviewed",
    name: "待审核用户",
    slug: "reviewed",
    icon: "UsersIcon",
  },
  {
    url: "/admin/scored",
    name: "待评分考核",
    slug: "scored",
    icon: "ClipboardIcon",
  },
  {
    url: "/admin/notes",
    name: "记录管理",
    slug: "notes",
    icon: "LayersIcon",
  },
  {
    url: "/admin/history",
    name: "历史数据",
    slug: "history",
    icon: "BoxIcon",
  },
  {
    url: "/admin/configure",
    name: "标准配置",
    slug: "configure",
    icon: "ArchiveIcon",
  },
  {
    url: "/admin/organization",
    name: "组织架构",
    slug: "organization",
    icon: "SlidersIcon",
  },
  {
    url: "/admin/role",
    name: "角色分配",
    slug: "role",
    icon: "UserCheckIcon",
  },
  {
     header: "统计",
   },
  {
    url: "/charts",
    name: "统计分析",
    slug: "charts",
    icon: "AirplayIcon",
  },
]
